import Link from 'next/link'
import { routePaths } from '@/shared/config/site'
import { cn } from '@/shared/lib/cn'

type LandingHomeLinkProps = {
  className?: string
}

export function LandingHomeLink({ className }: LandingHomeLinkProps) {
  return (
    <Link
      aria-label={'Back Home'}
      className={cn(
        'inline-flex h-10 w-10 items-center justify-center rounded-md transition-colors duration-150 hover:bg-secondary focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary/70',
        className,
      )}
      href={routePaths.home}
    >
      <img
        alt={'Autist avatar for Vitaliy'}
        className="h-8 w-8 object-contain"
        decoding="async"
        height={77}
        src={'/localization/autist-nav.webp'}
        width={80}
      />
    </Link>
  )
}
